import { Outlet } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useIntlContext } from '@sorare/core/src/contexts/intl';
import { SportSwitcher } from '@sorare/core/src/contexts/sport/SportSwitcher';
import { sportToBlogSportMap } from '@sorare/core/src/lib/routing';

import { Post } from '#src/components/Post/index.tsx';

import type { LayoutParams } from './__generated__/routeParams.ts';

const Layout = () => {
  const { sport, category = '' } = useTypedParams<LayoutParams>();
  const { language } = useIntlContext();

  const sportKey = Object.entries(sportToBlogSportMap).find(
    ([, value]) => value === sport
  )?.[0] as Sport | undefined;

  if (!sportKey) {
    return <Post slug={sport} language={language} category={category} />;
  }

  return (
    <>
      <SportSwitcher sport={sportKey} />
      <Outlet />
    </>
  );
};

export default Layout;
